var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAcheived(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.098 5s-2.184.583-2.788 1.167C5.707 6.75 5.16 8.033 4.442 8.5c-.718.467-1.81.642-2.442.613.316.729 2.643 6.066 2.643 6.066s1.868-.146 2.5-.612c.633-.467.891-1.109 1.15-1.488.259-.379.374-.612.69-.904.316-.292.747-.554 1.178-.642.43-.087 1.236-.204 1.523-.146C11.454 10.921 9.098 5 9.098 5zm5.948 13.708l-3.39-7.379M14.902 5s2.184.583 2.788 1.167c.603.583 1.15 1.866 1.868 2.333.718.467 1.81.642 2.442.613-.316.729-2.643 6.066-2.643 6.066s-1.868-.146-2.5-.612c-.633-.467-.891-1.109-1.15-1.488-.259-.379-.374-.612-.69-.904-.316-.292-.747-.554-1.178-.642-.43-.087-1.236-.204-1.523-.146.23-.466 2.586-6.387 2.586-6.387zM8.954 18.708l3.39-7.379",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })));
}

export default SvgIconAcheived;